import { useCallback } from 'react';
import type { JSX } from 'react';

import { Waypoint } from 'react-waypoint';

import type { WaypointCallbackArgs } from 'src/app/shared/components/layout/lazy';

// FIXME move this file to page's shared/hooks folder
// eslint-disable-next-line @change/sibling-module-imports
import { usePageScrollPosition } from '../../hooks/scroll';

export function AfterDescriptionWaypoint(): JSX.Element {
	const { setAfterDescription } = usePageScrollPosition();

	const onPositionChange = useCallback(
		({ currentPosition }: WaypointCallbackArgs) => setAfterDescription(currentPosition === 'above'),
		[setAfterDescription],
	);

	// using onPositionChange so that it is triggered at hydration
	return <Waypoint onPositionChange={onPositionChange} />;
}
